export const GarbageData = {
    "collecteurs": {
        "id": "collecteurs",
        "items": [
            {
                "id": "ampoule"
            },
            {
                "id": "bouchons_plastiques"
            },
            {
                "id": "capsules_cafe"
            },
            {
                "id": "cartouches_encre"
            },
            {
                "id": "jouets"
            },
            {
                "id": "medicaments"
            },
            {
                "id": "piles"
            },
            {
                "id": "stylos"
            },
            {
                "id": "tel_portable"
            },
            {
                "id": "torchon_dechire"
            },
            {
                "id": "vetements"
            },
        ],
    },
    "compost": {
        "id": "compost",
        "name": "Compost",
        "items": [
            {
                "id": "coquilles_oeuf"
            },
            {
                "id": "epluchure_patate"
            },
            {
                "id": "feuilles_mortes"
            },
            {
                "id": "fleur_fanee"
            },
            {
                "id": "gazon"
            },
            {
                "id": "marc_cafe"
            },
            {
                "id": "pain_rassis"
            },
            {
                "id": "peau_banane"
            },
            {
                "id": "reste_pates"
            },
            {
                "id": "reste_repas"
            },
            {
                "id": "sachet_the"
            },
            {
                "id": "trognon_pomme"
            },
            {
                "id": "viande_poisson"
            },
        ],
    },
    "dechetterie": {
        "id": "dechetterie",
        "items": [
            {
                "id": "batterie"
            },
            {
                "id": "bouteille_gaz"
            },
            {
                "id": "gravats"
            },
            {
                "id": "lave_linge"
            },
            {
                "id": "meuble"
            },
            {
                "id": "miroir_casse"
            },
            {
                "id": "pneumatique"
            },
            {
                "id": "pot_peinture"
            },
            {
                "id": "pots_fleur"
            },
            {
                "id": "souche_arbre"
            },
            {
                "id": "velo_casse"
            },
        ],
    },
    "poubelle_dechets": {
        "id": "poubelle_dechets",
        "items": [
            {
                "id": "barquette_alimentaire"
            },
            {
                "id": "barquette_beurre"
            },
            {
                "id": "boite_fromage_bois"
            },
            {
                "id": "boite_oeuf_plastique"
            },
            {
                "id": "boite_pizza"
            },
            {
                "id": "cahier_spirale"
            },
            {
                "id": "coquillage_crustace"
            },
            {
                "id": "couche"
            },
            {
                "id": "emballage_plastique"
            },
            {
                "id": "emballage_polystyrene"
            },
            {
                "id": "emballage_souille"
            },
            {
                "id": "enveloppe_fenetre"
            },
            {
                "id": "flacon_huile_moteur"
            },
            {
                "id": "mouchoir_usage"
            },
            {
                "id": "os_arete"
            },
            {
                "id": "papier_alu"
            },
            {
                "id": "papier_bonbon"
            },
            {
                "id": "papier_photo"
            },
            {
                "id": "pot_yaourt_plastique"
            },
            {
                "id": "poussiere_apirateur"
            },
            {
                "id": "sac_plastique"
            },
            {
                "id": "ticket_caisse"
            },
            {
                "id": "ticket_tram"
            },
            {
                "id": "vaisselle_faience"
            },
            {
                "id": "vaisselle_jetable"
            },
            {
                "id": "verre_casse"
            },
        ],
    },
    "poubelle_bleue": {
        "id": "poubelle_bleue",
        "items": [
            {
                "id": "agenda"
            },
            {
                "id": "annuaire"
            },
            {
                "id": "cahier"
            },
            {
                "id": "courrier"
            },
            {
                "id": "enveloppe"
            },
            {
                "id": "feuille_papier"
            },
            {
                "id": "journaux"
            },
            {
                "id": "lettre_manuscrite"
            },
            {
                "id": "livres"
            },
            {
                "id": "magazines"
            },
            {
                "id": "prospectus"
            },
            {
                "id": "vieux_livre"
            },
        ],
    },
    "poubelle_verte": {
        "id": "poubelle_verte",
        "items": [
            {
                "id": "bocal_cornichons"
            },
            {
                "id": "bocal_verre"
            },
            {
                "id": "bouteille_eau_petillante"
            },
            {
                "id": "bouteille_huile_verre"
            },
            {
                "id": "bouteille_sirop"
            },
            {
                "id": "bouteille_vin"
            },
            {
                "id": "bouteille_vinaigre"
            },
            {
                "id": "bouteilles_biere"
            },
            {
                "id": "flacon_parfum"
            },
            {
                "id": "flacons_divers"
            },
            {
                "id": "pot_confiture"
            },
            {
                "id": "pot_yaourt_verre"
            },
        ],
    },
    "poubelle_jaune": {
        "id": "poubelle_jaune",
        "items": [
            {
                "id": "aerosols"
            },
            {
                "id": "baril_lessive"
            },
            {
                "id": "barquette_aluminium"
            },
            {
                "id": "bidon_lessive"
            },
            {
                "id": "bidon_sirop"
            },
            {
                "id": "boite_biscuits"
            },
            {
                "id": "boite_cafe"
            },
            {
                "id": "boite_conserve"
            },
            {
                "id": "boite_oeufs"
            },
            {
                "id": "boite_sardines"
            },
            {
                "id": "bombe_chantilly"
            },
            {
                "id": "bouteille_eau"
            },
            {
                "id": "bouteille_huile_plastique"
            },
            {
                "id": "bouteille_lait"
            },
            {
                "id": "bouteille_soda"
            },
            {
                "id": "brique_creme_fraiche"
            },
            {
                "id": "brique_jus_fruits"
            },
            {
                "id": "brique_lait"
            },
            {
                "id": "brique_soupe"
            },
            {
                "id": "cannette"
            },
            {
                "id": "carton_suremballage"
            },
            {
                "id": "couvercle_metallique"
            },
            {
                "id": "emballage_jouet"
            },
            {
                "id": "flacon_geldouche"
            },
            {
                "id": "flacon_ketchup"
            },
            {
                "id": "flacon_liquide_vaisselle"
            },
            {
                "id": "flacon_mayonnaise"
            },
            {
                "id": "flacon_produit_menager"
            },
            {
                "id": "flacon_sanitaire"
            },
            {
                "id": "flacon_shampoing"
            },
            {
                "id": "guirlande_papier"
            },
            {
                "id": "mousse_raser"
            },
            {
                "id": "paquet_biscuits"
            },
            {
                "id": "paquet_cereales"
            },
            {
                "id": "papier_cadeau"
            },
            {
                "id": "plat_aluminium"
            },
            {
                "id": "rouleau_papier_toilette"
            },
            {
                "id": "rouleau_sopalin"
            },
            {
                "id": "sac_papier"
            },
        ],
    },
};
